var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKoek = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 303.08 430.25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4cb48b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,171.1c-20.16,42.21-35.66,91.28,1.76,143,10.08,14,23.85,28.81,38.58,43.08V107.67C44.61,130.43,29.64,153,21,171.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.86,85.26V373.07c9.91,8.67,19.79,16.86,28.93,24.2V50.32C98.58,61.13,88.68,73,78.86,85.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.19,93.9C211.06,68.58,191,44.15,176.25,26.56,162,10.4,152.33,0,152.33,0s-11.08,11.93-27,30.09V196.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.92,231.23l-27.86,27.28,87.58,88.07a321.33,321.33,0,0,0,26-29.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.41,171.73c-2.8-5.7-6.21-11.84-10.08-18.29l-66.74,65.37,83.21,83.66C315.62,255.24,300.55,210.58,281.41,171.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.39,270.93,125.3,296.49V411c15.17,11.67,25.59,19.05,25.83,19.22,0,0,13.75-9.47,32.88-24.07,16.09-12.79,36.17-29.49,54.93-47.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "261.72 137.96 125.38 271.52 125.38 221.36 240.95 108.14 261.72 137.96"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKoek);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/KOEK.81606f178cf72453c7caf7bc4fa45a83.svg";